import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FaHistory, FaSpinner } from 'react-icons/fa';
import { fetchImportHistoryDetail } from '../services/utilityService';
import { ImportResults } from './ImportJobSchedulesUtility';

const ImportJobSchedulesHistoryDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchImportHistoryDetail(id);
        setRecord(res.data);
      } catch (err) {
        setError(err.message || 'Failed to load import record.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const formatDate = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    return d.toLocaleString('en-AU', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  };

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between px-4 sm:px-0">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900 flex items-center gap-2">
            <FaHistory className="text-orange-500" /> Import Detail
          </h1>
          {record && (
            <div className="flex items-center gap-4 mt-1 text-sm text-gray-500">
              <span>{formatDate(record.importedAt)}</span>
              <span className="font-mono bg-gray-100 rounded px-2 py-0.5 text-xs">{record.fileName}</span>
              <span>by {record.importedBy?.email || '—'}</span>
            </div>
          )}
        </div>
        <Link
          to="/utilities/import-job-schedules/history"
          className="text-sm text-gray-500 hover:text-gray-700 underline"
        >
          Import History
        </Link>
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex items-center justify-center py-20 text-gray-500 gap-2">
          <FaSpinner className="animate-spin" /> Loading...
        </div>
      ) : error ? (
        <div className="mx-4 sm:mx-0 p-8 bg-red-50 border border-red-200 rounded-lg text-center text-red-700">{error}</div>
      ) : record ? (
        <div className="px-4 sm:px-0">
          <ImportResults
            results={{
              imported: record.summary?.imported || 0,
              failed: record.summary?.failed || 0,
              results: record.results || [],
            }}
            isHistoryView={true}
            onBackToHistory={() => navigate('/utilities/import-job-schedules/history')}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ImportJobSchedulesHistoryDetailPage;
